import { MappingItem } from '@corratech/pylot-gtm/src/GTM'
import { pdpItemMapping } from 'stores/ooka_usa_store/components/OOKA/pylot-gtm/src/mapping/events/pdpItemMapping'

export const pdpRelatedProductsData = (
    itemMapping = pdpItemMapping()
): MappingItem => {
    return {
        related_products_list: {
            data_source: ['related_products'],
            mapping: itemMapping,
            strict: true
        }
    }
}
